export default __webpack_public_path__ + "static/media/IconDesc_QuantumCrystal.256.7fc46590.png";